import { useLayout } from "../contexts/LayoutContext";
import Sidebar from "./Sidebar";
import AppBar from "./AppBar";
import Footer from "./Footer";
import ReminderInboxDrawer from "../components/reminders/ReminderInboxDrawer";
import "./Shell.scss";

/**
 * Root layout: two independent columns.
 * Left column  — Sidebar (fixed width, full height)
 * Right column — AppBar + Content + Footer (fills remaining width)
 *
 * On mobile the sidebar is a drawer overlay, so only the right column renders.
 */
const Shell = ({ children }) => {
  const { isSmall } = useLayout();

  return (
    <div className="shell">
      {isSmall ? <Sidebar /> : (
        <aside className="shell__sidebar">
          <Sidebar />
        </aside>
      )}

      <div className="shell__main">
        <AppBar />
        <main className="shell__content">
          {children}
        </main>
        <Footer />
      </div>
      <ReminderInboxDrawer />
    </div>
  );
};

export default Shell;
